import Schema from '../Schema';

import {
  SHIPPING_METHODS,
  SHIPPING_METHODS_PATTERN
} from '../../../../../../lib/document/schema/shipping_method';
import {
  STATE,
  STATE_PATTERN,
  DISPLAY_STATE,
  PENDING_METHODS_PATTERN,
  PENDING_METHODS
} from '../../../../../../lib/document/schema/shipment_groups';

const ShipmentGroups = new Schema({
  _id: String,

  state: {
    type: String,
    enum: STATE_PATTERN,
    default: STATE.PREPARATION
  },

  // この配送に関連するOrders
  orders: [
    {
      type: String,
      ref: 'Orders'
    }
  ],

  pending_method: {
    type: String,
    enum: PENDING_METHODS_PATTERN
  },

  // この配送に含まれるShipment
  shipments: [
    {
      type: String,
      ref: 'Shipments'
    }
  ],

  // 発送日
  shipped_at: Date,

  // 配送予定日を表示するかどうか
  display_expected_ship_at: Boolean,

  // 配送予定日
  expected_ship_at_by_status: Date,

  // 倉庫の場所
  region: String,

  // Shipment群の配送方法
  shipping_methods: {
    type: String,
    enum: SHIPPING_METHODS_PATTERN,
    default: SHIPPING_METHODS.EMS.value
  },

  // 配送先情報
  shipping_address: {
    name: String,
    country: String,
    zip: String,
    state: String,
    city: String,
    line1: String,
    line2: String,
    tel: String,
    tax_code: String
  },
  // 配送会社の配送物追跡コード
  tracking_code: String,
  // 配送会社の配送物追跡URL
  tracking_url: String,

  // regionがCommerce、stateがstandbyの場合
  newgistics_shipment: {
    status: String
  },

  // standbyの処理中かどうか
  is_in_process_for_standby: Boolean
});

ShipmentGroups.STATE = STATE;
ShipmentGroups.DISPLAY_STATE = DISPLAY_STATE;
ShipmentGroups.PENDING_METHODS = PENDING_METHODS;

// 表示する配送ステータスラベル
ShipmentGroups.getShippingStateLabel = function (shipmentGroup) {
  switch (shipmentGroup.state) {
    case STATE.RETURNED:
      return DISPLAY_STATE.RETURNED;
    case STATE.REFUNDED:
      return DISPLAY_STATE.REFUNDED;
    case STATE.PENDING:
      return DISPLAY_STATE.PENDING;
    case STATE.DELIVERED:
      return DISPLAY_STATE.DELIVERED;
    case STATE.STANDBY:
    case STATE.PICKUPED:
      if (
        shipmentGroup.newgistics_shipment &&
        shipmentGroup.newgistics_shipment.status !== 'PRINTED' &&
        shipmentGroup.newgistics_shipment.status !== 'VERIFIED'
      ) {
        return DISPLAY_STATE.ORDERED;
      }
      return DISPLAY_STATE.SHIPPING_SOON;
    case STATE.PACKAGED:
      return DISPLAY_STATE.PACKAGED;
    case STATE.SHIPPED:
      return DISPLAY_STATE.SHIPPED;
    case STATE.ORDERED:
      return DISPLAY_STATE.ORDERED;
    case STATE.CANCEL_REQUESTED:
      return 'Cancellation Requested';
    default:
      if (ShipmentGroups.hasPreOrderSku(shipmentGroup)) {
        return DISPLAY_STATE.PRE_ORDERED;
      }
      return DISPLAY_STATE.BACK_ORDERED;
  }
};

ShipmentGroups.hasPreOrderSku = function (shipmentGroup) {
  const Shipments = ShipmentGroups.dependencyDocuments.Shipments;
  return shipmentGroup.shipments.every(function (id) {
    const s = Shipments.findById(id);
    return s && Shipments.hasPreOrderSku(s);
  });
};

// 配送方法のkey
ShipmentGroups.getShippingMethodKey = function (shipmentGroup) {
  return Object.keys(SHIPPING_METHODS).find(
    (s) => SHIPPING_METHODS[s].value === shipmentGroup.shipping_methods
  );
};

// 表示する配送方法
ShipmentGroups.getShippingMethodLabel = function (shipmentGroup) {
  const method = ShipmentGroups.getShippingMethodKey(shipmentGroup);
  if (!method) {
    return '';
  }
  return SHIPPING_METHODS[method].label;
};

// 配送にかかる目安日数
ShipmentGroups.getAverageDeliveryTime = function (shipmentGroup) {
  const method = ShipmentGroups.getShippingMethodKey(shipmentGroup);
  if (!method) {
    return '';
  }
  return SHIPPING_METHODS[method].average_delivery_time;
};

// 配送方法がBULK_SHIPPING_UPSGか
ShipmentGroups.isBulkShippingUPSG = function (shipmentGroup) {
  return (
    shipmentGroup.shipping_methods === SHIPPING_METHODS.BULK_SHIPPING_UPSG.value
  );
};

// 配送先住所をを変更できる状態かどうか
ShipmentGroups.canChangeAddress = function (shipmentGroup) {
  return (
    shipmentGroup.state === STATE.PREPARATION ||
    shipmentGroup.state === STATE.ORDERED
  );
};

// 配送予定日を表示するかどうか
ShipmentGroups.isDisplayExpectedShipAt = function (shipmentGroup) {
  return (
    shipmentGroup.state !== STATE.SHIPPED &&
    shipmentGroup.state !== STATE.DELIVERED
  );
};

// レビューが書き込める状態かどうか
ShipmentGroups.isReviewable = function (shipmentGroup) {
  return (
    (shipmentGroup.state === STATE.SHIPPED ||
      shipmentGroup.state === STATE.DELIVERED) &&
    !shipmentGroup.pending_method
  );
};

// state、regionに応じて、`Ships|Shipped From Japan|US` を返す
ShipmentGroups.shippingFrom = function (shipmentGroup) {
  const result = [];
  if (
    shipmentGroup.state === STATE.SHIPPED ||
    shipmentGroup.state === STATE.DELIVERED
  ) {
    result.push('Shipped From');
  } else {
    result.push('Ships From');
  }
  switch (shipmentGroup.region) {
    case 'Maihama':
      result.push('Japan');
      break;
    case 'Commerce':
      result.push('US');
      break;
  }
  return result;
};

export default ShipmentGroups;
